import React, { FC, useContext } from 'react'

import { Term, KampuspediaCtx, KampuspediaStatus } from 'components/utils/KampuspediaProvider'
import { css } from '@emotion/core'
import { useTheme } from 'emotion-theming'

import Button from 'components/common/atoms/Button'
import Ellipsis from 'components/common/atoms/Ellipsis'
import NewTypography from 'components/common/atoms/NewTypography'
import Container from 'components/layouts/atoms/Container'
import { TitlePopTermsSkeleton, TermsSkeleton } from './KampuspediaPopTermsSkeleton'

type KampuspediaPopTermsProps = {
  popTerms: Term[]
}

const kampuspediaPopTermsStyle = (theme: ThemeType) => css`
  .kampuspedia-pop-terms {
    padding: 24px 16px;
    background-color: ${theme.gray.gray10};
    &__title {
      margin-bottom: 16px;
    }
    &__term {
      padding: 4px 8px;
      margin: 0;
      .ellipsis {
        font-size: 12px;
      }
    }
    &__wrapper {
      display: flex;
      column-gap: 8px;
      row-gap: 8px;
      flex-wrap: wrap;
    }
    @media screen and (min-width: 768px) {
      padding: 40px 0 0 0;
      background-color: transparent;
      padding-bottom: 80px;
      &__title {
        font-weight: 600 !important;
        color: ${theme.gray.gray50};
      }
      &__term {
        padding: 8px 16px;
        height: 40px;
        .ellipsis {
          font-size: 14px;
        }
      }
    }
  }
`

const KampuspediaPopTerms: FC<KampuspediaPopTermsProps> = ({ popTerms }) => {
  const theme: ThemeType = useTheme()
  const { state } = useContext(KampuspediaCtx)
  return (
    <div css={kampuspediaPopTermsStyle(theme)}>
      <Container isMobileFull>
        <div className="kampuspedia-pop-terms">
          {state.status !== KampuspediaStatus.completed ? (
            <TitlePopTermsSkeleton />
          ) : (
            <NewTypography tagName="div" variant="heading" level="1" className="kampuspedia-pop-terms__title">
              Istilah Terpopuler
            </NewTypography>
          )}

          <div className="kampuspedia-pop-terms__wrapper">
            {state.status !== KampuspediaStatus.completed ? (
              <TermsSkeleton />
            ) : (
              popTerms?.map((term, idx) => (
                <Button
                  tagName="a"
                  href={`/kampuspedia/${term.slug}`}
                  key={`pop-term-${idx}`}
                  kind="select"
                  className="kampuspedia-pop-terms__term"
                  openNewTab={false}
                >
                  <Ellipsis text={term.title} clamp={1} />
                </Button>
              ))
            )}
          </div>
        </div>
      </Container>
    </div>
  )
}

export default KampuspediaPopTerms
